import moment from "moment";

export const formatTerminationDate = (terminationDate) => {
  return terminationDate ? moment(terminationDate).format("MM/DD/YYYY") : "N/A";
};
